/* istanbul ignore file */
export const getDefaultCampaignSearchStyles = (pageMenuItem, { palette = {} }) => ({
  loading: {
    backgroundColor: palette.white,
    paddingTop: '6px',
    paddingBottom: '6px',
  },
  searchResultDropDown: {
    zIndex: '10',
    boxShadow: '0px 0.6px 1.8px rgba(0, 0, 0, 0.108), 0px 3.2px 7.2px rgba(0, 0, 0, 0.132)',
    borderRadius: '2px',
  },
  resultHeader: {
    marginTop: '10px',
    marginLeft: '16px',
    display: 'inline-block',
    fontWeight: 600,
  },
  resultHeaderContainer: {
    lineHeight: '32px',
    backgroundColor: palette.white,
  },
  searchResultItem: {
    height: '48px',
    width: '100%',
    textAlign: 'left',
    borderWidth: '0px',
    paddingLeft: '0px',
    paddingRight: '0px',
    backgroundColor: palette.white,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    cursor: 'pointer',
    color: 'rgba(0, 0, 0, 0)', // Hides the fallback glyph
    '& .iconba.iconba-Forward': {
      marginRight: 4,
    },
  },
  divider: {
    width: '100%',
    borderTop: `solid 0.5px ${palette.neutralLight}`,
  },
  searchItemContainer: {
    height: '48px',
    width: '100%',
    textAlign: 'left',
    borderWidth: '0px',
    display: 'flex',
    flexDirection: 'row',
    paddingTop: '13px',
    paddingBottom: '16px',
    paddingLeft: '16px',
    paddingRight: '5px',
    '&:hover': {
      color: palette.themePrimary,
    },
  },
  calloutTargetContainer: {
    width: '100%',
  },
  fallbackGlyph: {
    fontSize: 16,
    float: 'right',
    lineHeight: '19px',
    color: 'inherit',
  },
  searchItemSpan: {
    display: 'inline-block',
    color: palette.neutralPrimary,
    flex: '1 1 1px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  searchItemFooterSpan: {
    color: palette.themePrimary,
  },
  shortcutItem: {
    display: 'flex',
    color: palette.neutralSecondary,
    paddingRight: 6,
  },
  shortcutKey: {
    display: 'inline-block',
    border: '1px solid #979797',
    borderRadius: 2,
    fontSize: 12,
    fontWeight: 600,
    lineHeight: '16px',
    width: 14,
    textAlign: 'center',
    '&:first-child': {
      marginRight: 6,
    },
  },
  statusIconContainer: {
    marginTop: 6,
    marginRight: 8,
  },
  activeStatusIcon: {
    fontSize: '12px !important',
    color: '#107C10',
    display: 'block',
    top: '0 !important',
    margin: '0px !important',
  },
  pausedStatusIcon: {
    fontSize: '12px !important',
    color: '#797775',
    display: 'block',
    top: '0 !important',
    margin: '0px !important',
  },
});
